module.exports = "<c4-static-review-message *ngIf=\"data\" [data]=\"data\"></c4-static-review-message>\n<ng-template #container>\n</ng-template>"